import { LOGIN_REQUEST, LOGIN_SUCCESS, LOGIN_FAIL } from "../types/authTypes";
import Axios from 'axios';
import APP_CONSTANT from '../../config/constants'
import { setCustomerDetails } from "./../../components/utils/constants";

export const login = (loginData) => async (dispatch) => {
    dispatch({ type: LOGIN_REQUEST });
    try {
        const headerData = JSON.stringify({
            username: loginData.username,
            password: loginData.password
        })

        const { data } = await Axios.post(`${APP_CONSTANT.BASE_URL}sso/login`, headerData, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': "*",
            }
        });

        dispatch({ type: LOGIN_SUCCESS });
        let token = data.resultSet.token
        let userId = data.resultSet.userId
        let role = data.resultSet.role
        let realName = data.resultSet.userName
        let customerNo = data.resultSet.customerNo
        let vendorId = data.resultSet.vendorId
        let userKey = data.resultSet.userKey
        let speedToken = data.resultSet.speedToken
        const { customerName, customerCompanyName, customerLogo } = data.resultSet;

        localStorage.setItem('apiToken', token)
        localStorage.setItem('realName', realName)
        localStorage.setItem('userId', userId)
        localStorage.setItem('userKey', userKey)
        localStorage.setItem('speedToken', speedToken)
        localStorage.setItem('role', role)
        localStorage.setItem('customerNo', customerNo)
        localStorage.setItem('vendorId', vendorId)
        setCustomerDetails('customerName', customerName)
        setCustomerDetails('customerCompanyName', customerCompanyName)
        setCustomerDetails('customerLogo', customerLogo)

        if (role === 'vendor') {
            window.location.href = '/'
        } else {
            window.location.href = '/salesorder'
        }

    } catch (error) {
        dispatch({ type: LOGIN_FAIL, payload: error.message })
    }
}

export const autoLogin = (globalAccessToken, userKeyToken) => async (dispatch) => {

    dispatch({ type: LOGIN_REQUEST });
    try {
        const headerData = JSON.stringify({
            speedToken: globalAccessToken,
            userKey: userKeyToken
        })

        const { data } = await Axios.post(`${APP_CONSTANT.BASE_URL}sso/auto_login`, headerData, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': "*",
            }
        });
        dispatch({ type: LOGIN_SUCCESS });
        let token = data.resultSet.token
        let userId = data.resultSet.userId
        let role = data.resultSet.role
        let realName = data.resultSet.userName
        let customerNo = data.resultSet.customerNo
        let vendorId = data.resultSet.vendorId
        let userKey = data.resultSet.userKey
        let speedToken = data.resultSet.speedToken

        localStorage.clear()

        localStorage.setItem('apiToken', token)
        localStorage.setItem('realName', realName)
        localStorage.setItem('userId', userId)
        localStorage.setItem('userKey', userKey)
        localStorage.setItem('speedToken', speedToken)
        localStorage.setItem('role', role)
        localStorage.setItem('customerNo', customerNo)
        localStorage.setItem('vendorId', vendorId)

        if (customerNo == 1158 && role != "Vendor") {
            setTimeout(() => {
                window.location.href = "/salesOrder";
            }, 500);
        } else {
            setTimeout(() => {
                window.location.href = "/";
            }, 500);
        }

    } catch (error) {
        dispatch({ type: LOGIN_FAIL, payload: error.message })
    }
}